import * as React from 'react';

import { faChartPie, faEngine } from '@fortawesome/pro-solid-svg-icons';

import { KitIconNames } from '../../../_atomics/FontAwesomeIcon/types';
import QuickLinkSection from '../QuickLinkSection';
import { QuickLinkSectionItem } from '../QuickLinkSectionItem';

export interface SectionQuickLinksProps {
  showRebrandGuideAndAssetsLink?: boolean;
}

export const SectionQuickLinks: React.FC<SectionQuickLinksProps> = ({
  showRebrandGuideAndAssetsLink = false,
}) => (
  <QuickLinkSection title="Quick Links">
    <QuickLinkSectionItem
      href="https://engine.tech/docs/api-reference/#overview"
      kitIcon={KitIconNames.ApiSolid}
      target="_blank"
      title="API Reference"
    />
    <QuickLinkSectionItem
      href="https://engine.tech/control-center/guides/reporting"
      icon={faChartPie}
      target="_blank"
      title="Analytics"
    />
    {showRebrandGuideAndAssetsLink ? (
      <QuickLinkSectionItem
        href="https://engine.tech/s3/announcements/"
        icon={faEngine}
        target="_blank"
        title="Rebrand Guide & Assets"
      />
    ) : null}
  </QuickLinkSection>
);
